var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMetricSpeedBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.46 10a.9995.9995 0 00-.07 1 7.5492 7.5492 0 01.52 1.81 8 8 0 01-.69 4.73.9994.9994 0 01-.89.53H5.68a.9994.9994 0 01-.89-.54A8 8 0 0113 6.06a7.69 7.69 0 012.11.56.9999.9999 0 001-.07.9993.9993 0 00.4452-.9312A1.0002 1.0002 0 0015.94 4.79 10 10 0 003.35 19a2.0005 2.0005 0 001.72 1h13.85a1.9995 1.9995 0 001.74-1 9.9994 9.9994 0 00.55-8.89 1.0002 1.0002 0 00-1.75-.11z",
    fill: "#24272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 12.59a2.0011 2.0011 0 002.83 2.83l5.66-8.49-8.49 5.66z",
    fill: "#24272A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetricSpeedBlack);
export default __webpack_public_path__ + "static/media/Icon-Metric-Speed-Black.867340fb3f7bd3ea47db2af04261478d.svg";
export { ForwardRef as ReactComponent };